import React from 'react'
import { Box, Typography } from '@mui/material'

import { ENV_BANNER, ENV_BANNER_ENABLED } from 'qap/constants'
import QAPVars from 'qap/vars'

const EnvBanner = () => {
  if (!ENV_BANNER_ENABLED) return null

  return (
    <Box
      sx={theme => ({
        background: QAPVars.envBannerBackground,
        position: 'fixed',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: QAPVars.envBannerHeight,
        top: 0,
        width: '100%',
        zIndex: theme.zIndex.appBar + 1,
        '@media print': {
          display: 'none',
        },
      })}
    >
      <Typography sx={{ color: 'white', fontWeight: 600, textTransform: 'uppercase' }}>
        {ENV_BANNER}
      </Typography>
    </Box>
  )
}

export default EnvBanner
